import { Button } from "primereact/button";
import { OverlayPanel } from "primereact/overlaypanel";
import { useRef } from "react";

export type StaffAccessMatrixRow = {
  access: string;
  description: string;
  caregiver: boolean;
  nurse: boolean;
  mhp: boolean;
};

export const STAFF_ACCESS_MATRIX_ROWS: StaffAccessMatrixRow[] = [
  { access: "Binder", description: "View the resident binder and its shared records.", caregiver: false, nurse: true, mhp: true },
  { access: "Assessment", description: "Open and work with the resident's assessments.", caregiver: false, nurse: true, mhp: true },
  { access: "Search Care Plan", description: "Search the resident's care plan for support instructions and important care details.", caregiver: true, nurse: true, mhp: true },
  { access: "Care Plan Full Access", description: "Open the full care plan workspace to create, review, and update care-plan information.", caregiver: false, nurse: true, mhp: true },
  { access: "Delegation", description: "Manage nursing delegation instructions, tasks, and related forms.", caregiver: false, nurse: true, mhp: false },
  { access: "Daily Behavior Log", description: "Chart and review observed behaviors, interventions, and outcomes.", caregiver: true, nurse: true, mhp: true },
  { access: "Incident Reports", description: "Create and review reports for resident incidents.", caregiver: true, nurse: true, mhp: true },
  { access: "Progress Notes", description: "Create and review daily resident progress notes.", caregiver: true, nurse: true, mhp: true },
  { access: "eMAR", description: "View the medication list and chart medication administration within the staff member's permissions.", caregiver: true, nurse: true, mhp: true },
  { access: "ADL", description: "View and chart Activities of Daily Living support, tasks, and outcomes.", caregiver: true, nurse: true, mhp: true },
];

export const StaffAccessMatrixAction = ({ row }: { row: StaffAccessMatrixRow }) => {
  const helpPanel = useRef<OverlayPanel>(null);

  return (
    <div className="flex align-items-center gap-2">
      <span>{row.access}</span>
      <Button
        type="button"
        icon="pi pi-question-circle"
        text
        rounded
        severity="secondary"
        aria-label={`About ${row.access} access`}
        tooltip={row.description}
        tooltipOptions={{ position: "right", event: "hover" }}
        onClick={(event) => helpPanel.current?.toggle(event)}
        style={{ width: "2rem", height: "2rem", flexShrink: 0 }}
      />
      <OverlayPanel ref={helpPanel} dismissable>
        <div style={{ maxWidth: "20rem", color: "#334155", lineHeight: 1.5 }}>
          <strong style={{ color: "#0f172a" }}>{row.access}</strong>
          <div style={{ marginTop: "0.35rem" }}>{row.description}</div>
        </div>
      </OverlayPanel>
    </div>
  );
};
